<template>
  <div>
    <p class="mb-2">וטינג - {{ payload.vetting }}</p>
    <p class="mb-2">איתור - {{ payload.strong }}</p>
    <p class="mb-2">שליחה - {{ payload.send_by }}</p>
  </div>
</template>

<script>
export default {
  name: 'TableCellRecruiters',
  props: {
    payload: {
      type: Object
    }
  },
}
</script>
